import { initializeApp } from 'firebase/app';
import { getToken, isSupported, getMessaging } from 'firebase/messaging';

const firebaseApp = initializeApp({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
});
const getOrRegisterServiceWorker = async () => {
  const existing = await navigator.serviceWorker.getRegistration('/firebase-push-notification-scope');
  return existing || navigator.serviceWorker.register('/sw.js', { scope: '/firebase-push-notification-scope', type: 'classic' });
};
const getNotificationToken = (messaging, serviceWorkerRegistration) => getToken(messaging, {
  vapidKey: import.meta.env.VITE_FIREBASE_WEB_PUSH_CERT, serviceWorkerRegistration,
});
async function getPushRegistration() {
  if (!('Notification' in window) || !('serviceWorker' in navigator) || !(await isSupported())) {
    return { push_permission: 'unsupported', push_token: null, push_provider: null };
  }
  const {permission} = Notification;
  if (permission !== 'granted') return { push_permission: permission === 'denied' ? 'denied' : 'undetermined', push_token: null, push_provider: null };
  try {
    const token = await getNotificationToken(getMessaging(firebaseApp), await getOrRegisterServiceWorker());
    return token ? { push_permission: 'granted', push_token: token, push_provider: 'fcm_web' } : { push_permission: 'granted' };
  } catch { return { push_permission: 'granted' }; }
}
async function getNotificationPermission() {
  if (!('Notification' in window) || !(await isSupported())) return;
  await Notification.requestPermission(); // Only explicit user actions call this method.
  window.dispatchEvent(new Event('heyjobPushPermissionChanged'));
}
export default { getOrRegisterServiceWorker, getNotificationToken, getNotificationPermission, getPushRegistration, firebaseApp };
